import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { PageItem } from '../components/component-switcher';
import {
  backgroundStyle,
  ColorType,
  rounded,
  shadow,
} from '../helpers/style-helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';
import { copyToClipboard } from '../helpers/helpers';
import simpleColorConverter from 'simple-color-converter';

export interface ColorComponentProps extends PageItem {
  CMYK: string;
  HEX: string;
  RGB: string;
  RAL: string;
  pantone: string;
  showOpacityPalette: boolean;
}

export interface ColorComponentState {
  viewing: ViewingColor;
  showColorsList: boolean;
  showCopyToClipboard: boolean;
}

export interface ViewingColor {
  label: string;
  value: string;
}
class ColorComponent extends React.Component<
  ColorComponentProps,
  ColorComponentState
> {
  static contextType: Context<AppContextInterface | null> = AppContext;
  public context!: AppContextInterface;
  public state: ColorComponentState = {
    viewing: { label: 'HEX', value: this.props.HEX },
    showColorsList: false,
    showCopyToClipboard: false,
  };

  availableColors() {
    let result = [];
    if (this.props.CMYK) {
      result.push({ label: 'CMYK', value: this.props.CMYK });
    }
    if (this.props.HEX) {
      result.push({ label: 'HEX', value: this.props.HEX });
    }
    if (this.props.RGB) {
      result.push({ label: 'RGB', value: this.props.RGB });
    }
    if (this.props.pantone) {
      result.push({ label: 'Pantone', value: this.props.pantone });
    }
    if (this.props.RAL) {
      result.push({ label: 'RAL', value: this.props.RAL });
    }
    return result;
  }

  nextColor(e: any) {
    e.stopPropagation();
    const availableColors = this.availableColors();
    let current = availableColors.find(
      (item) => item.label === this.state.viewing.label
    );
    if (current) {
      let currentIndex = availableColors.indexOf(current);
      currentIndex++;
      const length = availableColors.length;
      if (currentIndex > length - 1) {
        this.setState({ viewing: availableColors[0] });
      } else {
        this.setState({ viewing: availableColors[currentIndex] });
      }
    }
  }

  prevColor(e: any) {
    e.stopPropagation();

    const availableColors = this.availableColors();
    let current = availableColors.find(
      (item) => item.label === this.state.viewing.label
    );
    if (current) {
      let currentIndex = availableColors.indexOf(current);
      currentIndex--;
      const length = availableColors.length;
      if (currentIndex < 0) {
        this.setState({ viewing: availableColors[length - 1] });
      } else {
        this.setState({ viewing: availableColors[currentIndex] });
      }
    }
  }

  mouseIn() {
    this.setState({ showCopyToClipboard: true });
  }
  mouseOut() {
    this.setState({ showCopyToClipboard: false });
  }

  copy(e: any) {
    const data = this.state.viewing;
    let color = e.target.style.backgroundColor;
    // if (data.label === 'HEX') {
    //   color = `${data.value}`;
    // }
    // if (data.label === 'RGB') {
    //   color = `rgb(${data.value.replace(/\./g, ',')})`;
    // }
    copyToClipboard(
      data.value,
      `<p style="margin:0;">${this.state.viewing.label}</p><p class="lg" style="display: flex;margin:0;
            justify-content: center;
            align-items: center;"><span style="background-color:
            ${color}
            ; border-radius: 25%; width:1em;height:1em;display:inline-block;margin-right:0.5em;"></span>
            ${this.state.viewing.value}</p><p style="margin:0;"> copied.</p>`
    );
  }
  copyColor = (
    v: string,
    bgColor?: string,
    override: boolean = false,
    delay?: number
  ) =>
    copyToClipboard(
      v,
      override
        ? v
        : `<p style="margin:0;">${v}</p><p class="lg" style="display: flex;margin:0;
            justify-content: center;
            align-items: center;"><span style="background-color:
            ${bgColor || v}
            ; border-radius: 25%; width:1em;height:1em;display:inline-block;margin-right:0.5em;"></span>
            ${v}</p><p style="margin:0;"> copied.</p>`,
      delay
    );
  generateColor = (color: string | undefined, alpha: number = 1) => {
    // function hexToRgb(hex: string) {
    //   var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    //   return result
    //     ? {
    //         r: parseInt(result[1], 16),
    //         g: parseInt(result[2], 16),
    //         b: parseInt(result[3], 16),
    //       }
    //     : null;
    // }
    const tintRgb = (
      rgb: { r: number; g: number; b: number } | null,
      factor: number
    ) => {
      if (rgb !== null) {
        let tint = 1 - factor;
        let tintedR = (rgb.r + (255 - rgb.r) * tint).toFixed(0);
        let tintedG = (rgb.g + (255 - rgb.g) * tint).toFixed(0);
        let tintedB = (rgb.b + (255 - rgb.b) * tint).toFixed(0);
        return { r: tintedR, g: tintedG, b: tintedB };
      }
    };
    // function valueToHex(v: number) {
    //   var hex = v.toString(16);

    //   return hex;
    // }
    // function rgbToHex(r: number, g: number, b: number) {
    //   return valueToHex(r) + valueToHex(g) + valueToHex(b);
    // }
    // function rgb2cmyk(r: number, g: number, b: number) {
    //   var computedC = 0;
    //   var computedM = 0;
    //   var computedY = 0;
    //   var computedK = 0;

    //   //remove spaces from input RGB values, convert to int
    //   var r = parseInt(('' + r).replace(/\s/g, ''), 10);
    //   var g = parseInt(('' + g).replace(/\s/g, ''), 10);
    //   var b = parseInt(('' + b).replace(/\s/g, ''), 10);

    //   if (
    //     r == null ||
    //     g == null ||
    //     b == null ||
    //     isNaN(r) ||
    //     isNaN(g) ||
    //     isNaN(b)
    //   ) {
    //     alert('Please enter numeric RGB values!');
    //     return;
    //   }
    //   if (r < 0 || g < 0 || b < 0 || r > 255 || g > 255 || b > 255) {
    //     alert('RGB values must be in the range 0 to 255.');
    //     return;
    //   }

    //   // BLACK
    //   if (r == 0 && g == 0 && b == 0) {
    //     computedK = 1;
    //     return [0, 0, 0, 1];
    //   }

    //   computedC = 1 - r / 255;
    //   computedM = 1 - g / 255;
    //   computedY = 1 - b / 255;

    //   var minCMY = Math.min(computedC, Math.min(computedM, computedY));
    //   computedC = (computedC - minCMY) / (1 - minCMY);
    //   computedM = (computedM - minCMY) / (1 - minCMY);
    //   computedY = (computedY - minCMY) / (1 - minCMY);
    //   computedK = minCMY;

    //   return [
    //     computedC * 100,
    //     computedM * 100,
    //     computedY * 100,
    //     computedK * 100,
    //   ];
    // }
    if (typeof color === 'string') {
      var hexToRgb = new simpleColorConverter({
        hex6: color,
        to: 'rgb',
      });
      let tinted = tintRgb(hexToRgb.color, alpha);
      if (tinted) {
        let rgbBg = `rgb(${tinted.r},${tinted.g},${tinted.b})`;
        if (this.state.viewing.label === 'RGB') {
          let rgb = `${tinted.r} - ${tinted.g} - ${tinted.b}`;
          this.copyColor(rgb, rgbBg);
        }
        if (this.state.viewing.label === 'HEX') {
          let hex = new simpleColorConverter({
            rgb: tinted,
            to: 'hex6',
          });
          this.copyColor(`#${hex.color}`, rgbBg);
        }
        console.log(this.state.viewing.label);
        if (this.state.viewing.label === 'Pantone') {
          if (alpha === 1) {
            this.copyColor(this.state.viewing.value, rgbBg);
          } else {
            let pantone = new simpleColorConverter({
              rgb: tinted,
              to: 'pantone',
            });
            // this.copyColor(`${pantone.color}`, rgbBg);

            this.copyColor(
              `<p>Try <strong>${pantone.color}</strong>, <br/>or contact for accurate <br/>Pantone color.</p>`,
              rgbBg,
              true,
              3000
            );
          }
        }
        if (this.state.viewing.label === 'CMYK') {
          if (alpha === 1) {
            this.copyColor(this.state.viewing.value, rgbBg);
          } else {
            this.copyColor(
              `<p>Same color, <br/>just with ${(alpha * 100).toFixed(
                0
              )}% alpha</p>`,
              rgbBg,
              true,
              1500
            );
            // let cmyk = new simpleColorConverter({
            //   rgb: tinted,
            //   to: 'cmyk',
            // });
            // let c = cmyk.color?.c;
            // let m = cmyk.color?.m;
            // let y = cmyk.color?.y;
            // let k = cmyk.color?.k;
            // this.copyColor(`${c} - ${m} - ${y} - ${k}`, rgbBg);
          }
        }
      }
      // let rgb = hexToRgb(color);
      // let tintedRgb = tintRgb(rgb);
      // if (tintedRgb) {
      //   let r = Number(tintedRgb?.r);
      //   let g = Number(tintedRgb?.g);
      //   let b = Number(tintedRgb?.b);
      //   // console.log(this.state);
      //   if (this.state.viewing.label === 'HEX') {
      //     let hex = rgbToHex(r, g, b);
      //     if (tint_factor === 1) {
      //       this.copyColor(this.state.viewing.value, this.state.viewing.value);
      //     } else {
      //       this.copyColor(`#${hex.toUpperCase()}`, `#${hex.toUpperCase()}`);
      //     }
      //   }
      //   if (this.state.viewing.label === 'RGB') {
      //     console.log(color);
      //     // this.copyColor(`${r} - ${g} - ${b}`, `rgb(${r},${g},${b})`);
      //   }
      //   if (this.state.viewing.label === 'CMYK') {
      //     let cmyk = rgb2cmyk(r, g, b);
      //     let c = cmyk ? cmyk[0] : '';
      //     let m = cmyk ? cmyk[1] : '';
      //     let y = cmyk ? cmyk[2] : '';
      //     let k = cmyk ? cmyk[3] : '';

      //     this.copyColor(this.state.viewing.value, this.state.viewing.value);
      //     // if (tint_factor === 1) {
      //     //   this.copyColor(this.state.viewing.value, this.state.viewing.value);
      //     // } else {
      //     //   this.copyColor(
      //     //     `${c} - ${m} - ${y} - ${k}`,
      //     //     this.state.viewing.value
      //     //   );
      //     // }
      //   }
      // }
    }
  };

  render() {
    let dotStyle: React.CSSProperties = {
      backgroundColor: this.props.HEX,
      width: '100%',
      cursor: 'pointer',
    };
    const ac = this.availableColors();
    let className = 'color-component';
    if (this.props.showOpacityPalette) {
      className += ' with-opacity';
    }
    return (
      <div
        className={className}
        style={{
          ...backgroundStyle(this.context?.styles, ColorType.light),
          ...rounded(),
          ...shadow(this.context.styles),
        }}>
        <div
          onMouseEnter={this.mouseIn.bind(this)}
          onMouseLeave={this.mouseOut.bind(this)}
          className='color-dot flex-center'
          style={dotStyle}
          onClick={this.copy.bind(this)}>
          <div
            className='icon-container'
            style={{
              textAlign: 'center',
              opacity: this.state.showCopyToClipboard ? 1 : 0,
            }}>
            <FontAwesomeIcon icon={faCopy} />
          </div>
        </div>
        {this.props.showOpacityPalette && (
          <div className='opacity-palette'>
            <div
              style={{ ...dotStyle, opacity: 1 }}
              onClick={() => this.generateColor(dotStyle.backgroundColor, 1)}
            />
            <div
              style={{ ...dotStyle, opacity: 0.75 }}
              onClick={() => this.generateColor(dotStyle.backgroundColor, 0.75)}
            />
            <div
              style={{ ...dotStyle, opacity: 0.55 }}
              onClick={() => this.generateColor(dotStyle.backgroundColor, 0.55)}
            />
            <div
              style={{ ...dotStyle, opacity: 0.25 }}
              onClick={() => this.generateColor(dotStyle.backgroundColor, 0.25)}
            />
          </div>
        )}

        <div
          className={`type-selector ${
            ac.length > 1 ? 'type-selector--selectable' : ''
          }`}>
          <h3 className='user-select-none'>{this.props.title}</h3>
          <div onClick={this.nextColor.bind(this)}>
            <label>
              <span className='bold-text'>{this.state.viewing.label}</span>
              <span>
                {ac.length > 1 && (
                  <FontAwesomeIcon
                    // onClick={this.prevColor.bind(this)}
                    icon={faChevronUp}
                  />
                )}
              </span>
            </label>
            <label>
              <span>{this.state.viewing.value}</span>
              <span>
                {ac.length > 1 && (
                  <FontAwesomeIcon
                    // onClick={this.nextColor.bind(this)}
                    icon={faChevronDown}
                  />
                )}
              </span>
            </label>
          </div>
          {/* 
                    <ul className="colors-list" style={{transform: this.state.showColorsList ? 'scaleY(1)' : 'scaleY(0)'}}>
                        <li className="color-name"><span className="bold-text">{this.props.title}</span></li>
                        {this.props.CMYK && this.state.viewing !== 'CMYK' && <li onClick={() => this.setState({viewing: 'CMYK'})}><span className="bold-text">CMYK</span></li>}
                        {this.props.RGB && this.state.viewing !== 'RGB' && <li onClick={() => this.setState({viewing: 'RGB'})}><span className="bold-text">RGB</span></li>}
                        {this.props.HEX && this.state.viewing !== 'HEX' && <li onClick={() => this.setState({viewing: 'HEX'})}><span className="bold-text">Hexcode</span></li>}
                        {this.props.pantone && this.state.viewing !== 'Pantone' && <li onClick={() => this.setState({viewing: 'Pantone'})}><span className="bold-text">Pantone</span></li>}
                    </ul> */}
        </div>
      </div>
    );
  }
}

export default ColorComponent;
